export default "__VITE_ASSET__BRlGmTg3__"